import React from "react";
import BigNumber from "bignumber.js";

import Box from "../../Interface/Box";
import Separator from "../../Interface/Separator/Separator";
import BalanceRow from "../../Interface/BalanceRow";
import {address, convertBalance} from "../../../utils";
import {useSelector} from "react-redux";

function Stats() {
    const {totalStaked, userBalance: stakedUserBalance} = useSelector(store => store.staking);
    const {totalVotes, userBalance, userDelegate, userVotes} = useSelector(store => store.govToken);

    let votingPower = "0%";
    if (totalVotes !== "0") {
        let accountVotes = new BigNumber(userVotes);
        if (userDelegate === address(0)) {
            accountVotes = (new BigNumber(userVotes)).plus(new BigNumber(userBalance));
        }
        votingPower = accountVotes.dividedBy(new BigNumber(totalVotes)).multipliedBy(100).toFixed(2) + "%";
    }

    return (
        <Box direction="column" align="flex-start">
            DAO Stats
            <Separator />
            <BalanceRow name="Total Staked" value={convertBalance(totalStaked)} />
            <BalanceRow name="Staked by user" value={convertBalance(stakedUserBalance)} />
            <BalanceRow name="Your voting power" value={votingPower} />
        </Box>
    );
}

export default Stats;
